export default "__VITE_ASSET__LjuaVbpO__"